import { AccessorySizeView, type AccessoryField } from "./AccessorySizeView";
import type { TranslateFn } from "../../i18n";
import type { ViewState, SizeGuide } from "../types";

function buildFallbackWristFields(t: TranslateFn): AccessoryField[] {
  return [
    {
      key: "wristCircumference",
      label: t("Wrist Circumference"),
      placeholder: { cm: "e.g. 16.5", in: "e.g. 6.5" },
      hint: t("Measure around your wrist where the bracelet or watch sits"),
      min: 4,
      max: 30,
      step: 0.1,
    },
  ];
}

function buildFieldsFromSizeGuide(sizeGuide: SizeGuide | null | undefined, t: TranslateFn): AccessoryField[] {
  const req = sizeGuide?.requiredFields;
  if (!req || req.length === 0) return buildFallbackWristFields(t);
  const SIZE_CODE_KEYS = new Set(["size", "country", "eu", "__skip__"]);
  const fields = req
    .filter((f) => !SIZE_CODE_KEYS.has(f.key) && f.unit !== "size")
    .map((f) => ({
      key: f.key,
      label: t(f.label || f.key),
      placeholder: { cm: f.placeholder || "e.g. 16.5", in: f.placeholder || "e.g. 6.5" },
      min: 4,
      max: 30,
      step: 0.1,
    }));
  return fields.length > 0 ? fields : buildFallbackWristFields(t);
}

export function WristSizeView(props: {
  productImage: string;
  productTitle: string;
  formRef: React.MutableRefObject<Record<string, string>>;
  sizingUnit: string;
  setSizingUnit: (u: string) => void;
  setSizingMethod: (m: "exact" | "quick" | null) => void;
  setSizingLoading: (v: boolean) => void;
  setView: (v: ViewState) => void;
  submitSizing: (mode: "exact" | "quick") => void;
  onSnapSubmit: (data: {
    photoFile: File | null;
    photoBase64: string;
    height: number;
    weight: number;
    heightUnit: string;
    weightUnit: string;
    gender: string;
    age?: number;
  }) => void;
  onBack: () => void;
  apiUrl?: string;
  apiKey?: string;
  sizeGuide?: SizeGuide | null;
  t: TranslateFn;
}) {
  const { sizeGuide, t, ...rest } = props;
  const fields = buildFieldsFromSizeGuide(sizeGuide, t);
  return (
    <AccessorySizeView
      title={t("Wrist Measurements")}
      fields={fields}
      disablePhotoUpload
      t={t}
      {...rest}
    />
  );
}
